import { LitElement } from 'lit';
import { html, css } from 'lit';
import '../ContactTile/ContactTile';
import { Text } from '../Text/Text';
import '../Loader/Spinner/Spinner';

class SearchableList extends LitElement {
  static properties = {
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    padding: { type: String },
    height: { type: String },
    width: { type: String },
    time: { type: String },
    label: { type: String },
    alignSelf: { type: String },
    fontFamily: { type: String },
    textColor: { type: String },
    fontSize: { type: String },
    selectedContacts: { type: Array },
    contactList: { type: Array },
    conversationList: { type: Array },
    isSearching: { type: Boolean },
    getForwardMessageMemberList:{type: Function},
    onSend:{type: Function},
    isLoading: { type: Boolean },
    paginationLoading : {type: Boolean},
    hasMore : {type: Boolean},
    skip : {type: Number}
  };

  constructor() {
    super();
    this.textColor = 'var(--text-primary-color)';
    this.selectedContacts = [];
    this.debounceTimer = null;
    this.isSearching = false;
  }
  static styles = css`
    .searchable-list-container {
      display: flex;
      flex-direction: column;
    }

    .searchable-list-topbar {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--bg-primary-color);
      padding: 15px;
      color: var(--text-primary-color);
    }

    ::-webkit-scrollbar {
      width: 5px;
    }
    .searchable-list-body {
      display: flex;
      flex-direction: column;
      width: 100%;
      background-color: var(--bg-primary-color);
    }

    .searchable-list-searchbar {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 5px 10px;
      border-radius: 5px;
      background-color: var(--bg-secondary-color);
      margin: 10px;
    }

    .searchable-list-searchbar svg {
      width: 20px;
      height: 20px;
      fill: #0f0f0f;
    }

    input {
      border: none;
      outline: none;
      padding: 5px;
      width: 90%;
      background-color: transparent;
      color: var(--text-primary-color);
    }

    input::placeholder {
      color: var(--text-primary-color);
    }

    .searchable-list-tile {
      width: 100%;
      height: 50dvh;
      overflow-y: scroll;
      overflow-x: hidden;
    }

    .message-send-container {
      background-color: var(--bg-secondary-color);
      padding: 5px 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      padding: 10px;
    }
    .text-container {
      width: calc(100% - 44px);
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      padding-left: 10px;
    }

    .message-send-container.hidden {
      display: none;
    }

    @media (width < 768px) {
      .searchable-list-container {
        height: 100%;
      }
      .searchable-list-tile {
        height: 100%;
      }

      .searchable-list-body {
        height: 100%;
      }
    }

    .no-contacts {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      color: var(--text-primary-color);
      font-size: 14px;
    }
    
    .loader-container {
      display: flex;
      justify-content: center;
      padding: 20px;
    }
    
    .pagination-loader {
      display: flex;
      justify-content: center;
      padding: 10px;
    }
  `;

  handleContactSelection(event) {
    const { contactName, isChecked, contactConversationId, userId } = event.detail;
    if (isChecked) {
      this.selectedContacts = [...this.selectedContacts, { contactName, contactConversationId, userId }];
    } else {
      this.selectedContacts = this.selectedContacts.filter(contact => 
        !(contact.contactName === contactName && 
          (contact.contactConversationId === contactConversationId || contact.userId === userId))
      );
    }
    
    this.requestUpdate();
  }

  messageSend() {
    this.onSend(this.selectedContacts)
  }

  handleScroll(event) {
    const element = event.target;
    const threshold = 10;

    if ((element.scrollHeight - element.scrollTop <= element.clientHeight + threshold) && this.hasMore && !this.paginationLoading) {
      this.getForwardMessageMemberList(null, this.skip + 20)
    } 
  }

  handleSearch(event) {
    clearTimeout(this.debounceTimer);
    const searchText = event.target.value;
    
    this.isSearching = searchText.trim().length > 0;
    
    this.debounceTimer = setTimeout(() => {
      this.getForwardMessageMemberList(searchText)
    }, 300);
  }

  // Unified method to check if a contact is selected
  isContactSelected(item) {
    if (item.conversationId) {
      // This is a conversation item
      return this.selectedContacts.some(contact => 
        contact.contactConversationId === item.conversationId
      );
    } else if (item.userId) {
      // This is a user/contact item
      return this.selectedContacts.some(contact => 
        contact.userId === item.userId
      );
    }
    return false;
  }

  render() {
    const currentUrl = window.location.href;
    const urlParams = new URLSearchParams(new URL(currentUrl).search);
    const currentConversationID = urlParams.get('conversation')
    const filterdConversations = this.conversationList?.filter(conversation => conversation.conversationId !== currentConversationID);
  
    const svgSize = `calc(${this.fontSize} + 4px)`;
    return html`
      <div class="searchable-list-container" style="width: ${this.width}; font-family: ${this.fontFamily}">
        <div class="searchable-list-topbar">
          ${Text({
            content: this.label,
            fontSize: '22px',
            fontFamily: this.fontFamily,
            color: 'var(--text-outgoing-message)',
            fontWeight:'bold'
          })}
        </div>
        <div class="searchable-list-body">
          <div class="searchable-list-searchbar">
            <svg width="${svgSize}" height="${svgSize}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.0392 15.6244C18.2714 14.084 19.0082 12.1301 19.0082 10.0041C19.0082 5.03127 14.9769 1 10.0041 1C5.03127 1 1 5.03127 1 10.0041C1 14.9769 5.03127 19.0082 10.0041 19.0082C12.1301 19.0082 14.084 18.2714 15.6244 17.0392L21.2921 22.707C21.6828 23.0977 22.3163 23.0977 22.707 22.707C23.0977 22.3163 23.0977 21.6828 22.707 21.2921L17.0392 15.6244ZM10.0041 17.0173C6.1308 17.0173 2.99087 13.8774 2.99087 10.0041C2.99087 6.1308 6.1308 2.99087 10.0041 2.99087C13.8774 2.99087 17.0173 6.1308 17.0173 10.0041C17.0173 13.8774 13.8774 17.0173 10.0041 17.0173Z"
                  fill="${this.textColor}"
                ></path>
              </g>
            </svg>
            <input 
              placeholder="Search Contacts" 
              @input=${this.handleSearch}
            />
          </div>
          
          ${this.isLoading ? html`
            <div class="loader-container">
              <spinner-loader
                height="30px"
                width="30px"
                spinTime="1s"
                spinnerPrimaryColor="var(--bg-primary-color)"
                spinnerSecondaryColor="var(--text-primary-color)"
                spinnerBorderWidth="2px"
              ></spinner-loader>
            </div>
          ` : html`
            <div class="searchable-list-tile" @scroll=${this.handleScroll}>
              ${!this.isSearching && filterdConversations?.length > 0
                ? html`
                    <div>
                    
                    ${Text({
            content: 'Recent Chats',
            fontSize: '15px',
            color: 'var(--text-outgoing-message)',
            textAlign:"left"
          })}
                    </div>
                    ${filterdConversations?.map(
                      conversation => {
                        const isSelected = this.isContactSelected(conversation);
                        return html`
                          <contact-tile
                            @contact-selected=${this.handleContactSelection}
                            bgColor="var(--bg-primary-color)"
                            textColor="var(--text-primary-color)"
                            borderWidth="0px 0px 1px 0px"
                            borderColor="var(--bg-secondary-color)"
                            borderStyle="solid"
                            borderRadius="5px"
                            padding="10px"
                            height="auto"
                            width="100%"
                            imageSrc="${conversation?.conversationImageUrl || conversation?.opponentDetails?.userProfileImageUrl}"
                            contactName="${conversation?.conversationTitle || conversation?.opponentDetails?.userName}"
                            conversationId="${conversation?.conversationId}"
                            .isChecked=${isSelected}
                          ></contact-tile>
                        `;
                      }
                    )}
                  `
                : ''}
              <div style="padding: 10px;">
                    ${Text({
            content: this.isSearching ? 'Search Results' : 'Other Contacts',
            fontSize: '15px',
            color: 'var(--text-outgoing-message)',
            textAlign:"left"
          })}
              </div>
              <div>
              ${this.contactList?.length > 0 
                ? this.contactList.map(
                    contact => {
                      const isSelected = this.isContactSelected(contact);
                      return html`
                        <contact-tile
                          @contact-selected=${this.handleContactSelection}
                          bgColor="var(--bg-primary-color)"
                          textColor="var(--text-primary-color)"
                          borderWidth="0px 0px 1px 0px"
                          borderColor="var(--bg-secondary-color)"
                          borderStyle="solid"
                          borderRadius="5px"
                          padding="10px"
                          height="auto"
                          width="100%"
                          imageSrc="${contact?.userProfileImageUrl}"
                          contactName="${contact?.userName}"
                          userId="${contact?.userId}"
                          .isChecked=${isSelected}
                        ></contact-tile>
                      `;
                    }
                  )
                : html`
                    ${this.isSearching 
                      ? html`<div class="no-contacts">No contacts found</div>`
                      : ''
                    }
                  `
              }
              </div>
              
              ${this.paginationLoading ? html`
                <div class="pagination-loader">
                  <spinner-loader
                    height="20px"
                    width="20px"
                    spinTime="1s"
                    spinnerPrimaryColor="var(--bg-primary-color)"
                    spinnerSecondaryColor="var(--text-primary-color)"
                    spinnerBorderWidth="2px"
                  ></spinner-loader>
                </div>
              ` : ''}
            </div>
          `}
        </div>

        <div class="message-send-container ${this.selectedContacts.length === 0 ? 'hidden' : ''}" @click=${this.messageSend}>
          <div class="text-container">
            ${Text({
              content: this.selectedContacts.map(contact => contact.contactName).join(', '),
              color: this.textColor,
              fontSize: this.fontSize,
              textAlign: 'left',
            })}
          </div>
          <svg width="44px" height="44px" viewBox="-3.36 -3.36 30.72 30.72" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(1, 0, 0, 1, 0, 0)">
            <g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(0,0), scale(1)">
              <rect x="-3.36" y="-3.36" width="30.72" height="30.72" rx="15.36" fill="var(--base-color)" strokewidth="0"></rect>
            </g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M11.5003 12H5.41872M5.24634 12.7972L4.24158 15.7986C3.69128 17.4424 3.41613 18.2643 3.61359 18.7704C3.78506 19.21 4.15335 19.5432 4.6078 19.6701C5.13111 19.8161 5.92151 19.4604 7.50231 18.7491L17.6367 14.1886C19.1797 13.4942 19.9512 13.1471 20.1896 12.6648C20.3968 12.2458 20.3968 11.7541 20.1896 11.3351C19.9512 10.8529 19.1797 10.5057 17.6367 9.81135L7.48483 5.24303C5.90879 4.53382 5.12078 4.17921 4.59799 4.32468C4.14397 4.45101 3.77572 4.78336 3.60365 5.22209C3.40551 5.72728 3.67772 6.54741 4.22215 8.18767L5.24829 11.2793C5.34179 11.561 5.38855 11.7019 5.407 11.8459C5.42338 11.9738 5.42321 12.1032 5.40651 12.231C5.38768 12.375 5.34057 12.5157 5.24634 12.7972Z"
                stroke="var(--text-primary-color)"
                stroke-width="1.536"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </g>
          </svg>
        </div>
      </div>
    `;
  }
}

customElements.define('searchable-list', SearchableList);